import React from 'react';

import PageLayout from '@/layouts/PageLayout';

import ButtonBack from '@/components/ButtonBack';
import HeaderDefault from '@/components/HeaderDefault';

import PageContentProtocolosList from '../../components/PageContentProtocolosList';

const PageProtocolosList: React.FC = () => {
  return (
    <PageLayout
      Nav={
        <HeaderDefault
          title="Protocolos"
          subtitle="Selecione um protocolo para iniciar."
          Left={ButtonBack}
        />
      }
    >
      <PageContentProtocolosList />
    </PageLayout>
  );
};

export default PageProtocolosList;
